import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'components/Common/';
import { AvailablePopups } from 'store/app/types';
import getOPPlusContent from 'store/product/selector/getOPPlusContent';
import { useSelector } from 'react-redux';
import styles from './ContinueShopingPopup.module.scss';
import ContinueShoppingButton from './ContinueShoppingButton/ContinueShoppingButton';
import CheckoutButton from './CheckoutButton/CheckoutButton';
import ProductTitle from '../ProductTitle/ProductTitle';
import QuantitySelector from './QuantitySelector/QuantitySelector';
import ProductPrice from '../ProductPrice/ProductPrice';
import BundleProducts from './BundleProducts/BundleProducts';
import OthersAlsoBought from './OthersAlsoBought/OthersAlsoBought';
import ProductPreview from './ProductPreview/ProductPreview';
import CurrentProductAttributes from './CurrentProductAttributes/CurrentProductAttributes';
import OPPlusOffer from './OPPlusOffer/OPPlusOffer';

const ContinueShopingPopup = () => {
  const { t } = useTranslation();

  const offerOPPlus = useSelector(getOPPlusContent)?.displayUpsellPopup;
  return (
    <Popup popupId={AvailablePopups.continueShopingPopup} title={t('txt_opplus_upsell_basketupdated')}>
      <div className={styles.continueShoping}>
        <div className={styles.row}>
          <div className={styles.column}>
            <ProductPreview />
          </div>
          <div className={styles.rightColumn}>
            <div className={styles.cell}>
              <ProductTitle />
            </div>
            <div className={styles.cellWithPrice}>
              <BundleProducts />
              <CurrentProductAttributes />
              <ProductPrice />
              <div className={styles.quantitySelector}>
                <QuantitySelector />
              </div>
            </div>
          </div>
        </div>
        {offerOPPlus && <OPPlusOffer />}
        {!offerOPPlus && (
          <div className={styles.buttonGroup}>
            <CheckoutButton />
            <ContinueShoppingButton />
          </div>
        )}
        <OthersAlsoBought />
      </div>
    </Popup>
  );
};

export default ContinueShopingPopup;
